import { Modal, Form, Input, Select, message, DatePicker, Row, Col } from "antd";

import { useDispatch } from "react-redux";
import SubmitButton from "../../atoms/Buttons/SubmitButton";

export default function EditForm({
  title,
  isOpen,
  onClose,
  form,
  fields, // [{ label, name, rules, type }]
  submitThunk, // redux thunk for save
  payloadBuilder, // function to build payload from form values
  successMessage,
  currentPath,
  refreshListThunk, // optional, for re-fetching after save
}) {
  const dispatch = useDispatch();

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      const payload = payloadBuilder(values);
      
      dispatch(submitThunk({ ...payload, route: currentPath }))
        .unwrap()
        .then(() => {
          message.success(successMessage);
          onClose();
          if (refreshListThunk) {
            dispatch(
              refreshListThunk({
                route: currentPath,
                pagination: {
                  current: 1,
                  pageSize: process.env.REACT_APP_DEFAULT_PAGINATION_PAGESIZE,
                },
              })
            );
          }
        })
        .catch(() => {
          message.error("Failed to update.");
        });
    } catch (errInfo) {
      console.log("Validation Failed:", errInfo);
    }
  };

  const renderField = (field) => {
    switch (field.type) {
      case "input":
        return <Input {...(field.props || {})} />;
      case "number":
        return <Input type="number" {...(field.props || {})} />;
      case "select":
        return (
          <Select
            {...(field.props || {})}
            placeholder={field.props?.placeholder || ""}
            options={field.options || []}
            mode={field.multiple ? "multiple" : undefined}
            filterOption={field.filterOption}
            showSearch
            allowClear            
          />
        );
      case "datepicker":
        return (
          <DatePicker
            {...(field.props || {})}
            showTime
            picker={field.picker || "date"} // default 'date'
            format={field.format || "YYYY-MM-DD"}
            getPopupContainer={(trigger) => trigger.parentNode}
          />
        );
      case "custom":
        return field.render ? field.render(form) : null;
      default:
        return <Input {...(field.props || {})} />;
    }
  };

  return (
    <Modal
      className="custom-modal"
      title={title}
      open={isOpen}
      onCancel={onClose}
      footer={[
        <SubmitButton
          ky="cancel"
          type="primary"
          className="btn px-5 py-2 defaultWhiteBtn rounded-lg"
          submitName="Cancel"
          onClick={onClose}
        />,
        <SubmitButton
          ky="update"
          type="primary"
          className="btn px-5 py-2 defaultbutton rounded-lg"
          submitName="Update"
          onClick={handleSave}
        />,
      ]}
    >
      <Form className="editUserModalForm" form={form} layout="vertical">
        <Row gutter={[12, 12]}>
        {fields.map((field) => (
          <Col  xs={24}
  {...field?.colProps}>
          <Form.Item
            key={field.name}
            label={
              <>
                {field?.label}
                {field?.rules?.some(rule => rule.required) && (
                  <span className="postAstric" style={{ color: '#B12A26' }}>*</span>
                )}
              </>
            }
            name={field.name}
            rules={field.rules || []}
          >
            {renderField(field)}
          </Form.Item>
      </Col>
        ))}
        </Row>
      </Form>
    </Modal>
  );
}
